<template>
  <div>

     </div>


</template>

<script>
export default {
  
  methods: {
    clickMethod(val) {
       
      switch (val) {
        case 1:
          this.$emit("changeView", "MonthView");
         
        break;
        
        case 2:
          this.$emit("changeView", "WeeklyView");
        
          break;

        case 3:
          this.$emit("changeView", "LastEventView");
        
          break;
      }
    }
  }
};
</script>



<style lang="scss">
.clear-fix
{
    clear: both;
}

.contMenu
{
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  float: right;
}

.menu-item {
  background: tomato;
  padding: 5px;
  width: 200px;
  height: 150px;
  margin: 10px;
  line-height: 150px;
  color: white;
  font-weight: bold;
  font-size: 3em;
  text-align: center;
}



.toolbar {
  display: flex;
  align-items: center;
  margin: 5px;
  margin-bottom: 24px;
}

.toggle {
  align-content: right
}
.toggle__option {
  padding: 16px;
  border: 1px solid #e1e1e1;
  //border-radius: 8px;
  text-transform: capitalize;
  cursor: pointer;
}
.toggle__option:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.toggle__option:last-child {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.toggle__option--selected {
  border-color:#ecf0f1;
  background-color: white;
  color: var(--red);
  font-weight: 500;
  box-shadow: 1px 2px 30px -5px var(--red);
}


</style>
